import {configureStore} from '@reduxjs/toolkit';
import app from "./reducers/app";
import sw from "./reducers/search-widget";
import api from "../api";


const store = configureStore({
    reducer: {
        app,
        sw,
        [api.reducerPath]: api.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
});

export default store;
